module.exports = __webpack_public_path__ + "media/images/riders/small/DEAN_LUCAS-637ef559ab1688fb913c6c63fc6ca754.png";